module.exports = __webpack_public_path__ + "img/tablet.f0382373.svg";